module.exports = __webpack_public_path__ + "img/KSC06853.026d631b.jpg";